import type { Location } from '@remix-run/router';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isLinkActive = (url: string, location: Location<any>) => {
  return location.pathname === url;
};
